// extracted by mini-css-extract-plugin
export default {"PCButton":"PCButton_W168w","svgIcon":"svgIcon_SeTu6","PCLinkButton":"PCLinkButton_gMlkp"};